import L from "leaflet";
import { useEffect, useState } from "react";
import { useMap } from "../../providers/hooks/MapContext";

export default function ScaleControl() {
  const map = useMap();
  const [scaleControl, setScaleControl] = useState(null);

  // Set scale control
  useEffect(() => {
    if (map && !scaleControl) {
      const control = L.control
        .scale({ metric: true, imperial: false })
        .addTo(map);
      setScaleControl(control);
    }
  }, [map, scaleControl]);

  return <></>;
}
